import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { useState } from "react";

interface UniSatNotInstalledProps {
  text?: string;
}

const UniSatNotInstalled: React.FC<UniSatNotInstalledProps> = () => {
  const [open, setOpen] = useState(true);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className="relative z-30"
    >
      <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel className="relative transform overflow-hidden rounded-lg bg-gray-900 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-sm sm:translate-y-0 sm:scale-95">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
            >
              <XMarkIcon className="w-5 h-5" />
              <span className="sr-only">Close modal</span>
            </button>

            <div className="p-4 border-b rounded-t border-gray-600">
              <h3 className="text-base font-semibold text-white pr-8">
                Unisat wallet not found or an error occurred
              </h3>
            </div>

            <div className="p-4">
              <a
                href="https://chromewebstore.google.com/detail/unisat-wallet/ppbibelpcjmhbdihakflkdcoccbgbkpo"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-center group relative font-heading px-6 py-3 h-full w-full uppercase text-white font-semibold tracking-px bg-gradient-to-bl from-primary to-primaryHover overflow-hidden rounded-md transition-transform duration-500 active:scale-105"
              >
                <span className="absolute top-0 left-0 transform -translate-x-full group-hover:-translate-x-0 h-full w-full transition ease-in-out duration-500 bg-primaryHover" />
                <span className="relative z-10">Install Unisat</span>
              </a>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default UniSatNotInstalled;
